import { useRecoilValue } from "recoil";
import { authAtom } from "../shared/auth";
export const GetUserData = () => {
  const userDataInfo = useRecoilValue(authAtom);
  return userDataInfo;
};
